var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutPage',{staticClass:"news-page"},[(_vm.lastAddedPosts)?_c('PostsLastAdded',{attrs:{"posts":_vm.lastAddedPosts}}):_vm._e(),(!!_vm.posts)?_c('PostsFilter',{attrs:{"filters":_vm.filters,"posts":_vm.filterPosts},on:{"getLimitPosts":function($event){return _vm.init()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }